import styled from 'styled-components';

export const CardVerticalStyled = styled.div`
  height: 100%;
`;
